// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---NALfN","changedRecordsList":"changedRecordsList---g7oJw","changedRecord":"changedRecord---STzne"};